import '../App.css';
import React from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import { Form, Button, Table, Modal, Alert } from 'react-bootstrap';
import { claimUpload, claimGetClaims, claimUpdateClaim, claimGetClaimUsers } from '../Api';
import Header from '../Component/Header';
import moment from 'moment-timezone';
var timer

class ClaimData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',

      uploadModalShow: false,

      FileResultWord: '',
      // fromDate: moment(new Date()).startOf('week').subtract(7, 'd').toDate(),
      // toDate: moment(new Date()).startOf('week').toDate(),
      fromDate: moment('2025-06-30', 'YYYY-MM-DD').toDate(),
      toDate: moment('2025-07-06', 'YYYY-MM-DD').toDate(),

      allclaim: [],
      allUser: [],
      selectedUser: 'R637',
      userData: {
        user: '',
        winb1: 0,
        winb2: 0,
        winb3: 0,
        winb4: 0,
        winb5: 0,
        wins1: 0,
        wins2: 0,
        wins3: 0,
        wina1: 0,
        winc: 0,
        wina: 0,
      },
      totalObject: {
        claimb: 0,
        totalb: 0,
        claims: 0,
        totals: 0,
        claima1: 0,
        totala1: 0,
        claimc: 0,
        totalc: 0,
        claima: 0,
        totala: 0,
        claim: 0,
        total: 0,
      }
    }
    this.fileInputRef = React.createRef();
    this.UploadFiletxt = this.UploadFiletxt.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.openFileDialog = this.openFileDialog.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
  }

  async componentDidMount() {
    this.getClaimUser()
  }

  handleClose() {
    this.setState({ 
      uploadModalShow: false,
      FileResultWord: '',
    })
  }

  openFileDialog() {
    this.fileInputRef.current.click()
  }

  onDragOver(evt) {
    evt.preventDefault();
  }

  onDrop(event) {
    if (event !== undefined) {
      const files = event.dataTransfer.files;
      event.preventDefault()
      const reader = new FileReader()
      reader.onload = async (e) => {
        const text = (e.target.result)
        this.setState({ FileResultWord: text })
      };
      if (event.dataTransfer.files) {
        reader.readAsText(event.dataTransfer.files[0])
        this.setState({ FileName: files[0].name,hightlight: false })
      }
    }
  }

  async UploadFiletxt(event) {
    if (event !== undefined) {
      const files = event.target.files;
      event.preventDefault()
      const reader = new FileReader()
      reader.onload = async (e) => {
        const text = (e.target.result)
        this.setState({ FileResultWord: text })
      };
      if (event.target.files) {
        reader.readAsText(event.target.files[0])
        this.setState({ FileName: files[0].name })
      } 
    }
  }

  async CleanData() {
    this.setState({ FileName: '', FileResultWord: '' })
  }

  ChangeReceipt(event) {
    const PressNumber = event.target.value
    this.setState({ FileResultWord: PressNumber })
  }

  openNotification(message, type) {
    this.setState({ notificationMessage: message, notificationType: type }, () => {
      this.setState({ showNotification: true });
    });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({
        showNotification: false,
        notificationMessage: ''
      });
    }, 2000);
  };

  async claimUpload() {
    const claimUploadResult = await claimUpload(this.props.username, this.props.token, this.state.FileResultWord)
    if (claimUploadResult.error){
      this.openNotification(claimUploadResult.error, '')
    } else if (claimUploadResult.message && claimUploadResult.message === 'Data upload Successful') {
      this.openNotification('增加成功', '')
      this.handleClose()
      this.getClaims();
    }
  }

  async getClaims() {
    const allclaim = await claimGetClaims(this.props.username, this.props.token, moment(this.state.fromDate).format('YYYY-MM-DD'), moment(this.state.toDate).format('YYYY-MM-DD'), this.state.selectedUser)
    const totalclaimobject = {
      claimb: 0,
      totalb: 0,
      claims: 0,
      totals: 0,
      claima1: 0,
      totala1: 0,
      claimc: 0,
      totalc: 0,
      claima: 0,
      totala: 0,
      claim: 0,
      total: 0,
    }
    const allclaimresult = allclaim.result
    const userData = allclaim.userData
    for (let i = 0; i < allclaimresult.length; i += 1) {
      if (allclaimresult[i].b) {
        totalclaimobject.claimb += allclaimresult[i].claimb * userData[`winb${allclaimresult[i].position}`]
        totalclaimobject.claim += allclaimresult[i].claimb * userData[`winb${allclaimresult[i].position}`]
        totalclaimobject.totalb += allclaimresult[i].b * userData[`winb${allclaimresult[i].position}`]
        totalclaimobject.total += allclaimresult[i].b * userData[`winb${allclaimresult[i].position}`]
      }
      if (allclaimresult[i].s) {
        totalclaimobject.claims += allclaimresult[i].claims * userData[`wins${allclaimresult[i].position}`]
        totalclaimobject.claim += allclaimresult[i].claims * userData[`wins${allclaimresult[i].position}`]
        totalclaimobject.totals += allclaimresult[i].s * userData[`wins${allclaimresult[i].position}`]
        totalclaimobject.total += allclaimresult[i].s * userData[`wins${allclaimresult[i].position}`]
      }
      if (allclaimresult[i].a1) {
        totalclaimobject.claima1 += allclaimresult[i].claima1 * userData[`wina1`]
        totalclaimobject.claim += allclaimresult[i].claima1 * userData[`wina1`]
        totalclaimobject.totala1 += allclaimresult[i].a1 * userData[`wina1`]
        totalclaimobject.total += allclaimresult[i].a1 * userData[`wina1`]
      }
      if (allclaimresult[i].a) {
        totalclaimobject.claima += allclaimresult[i].claima * userData[`wina`]
        totalclaimobject.claim += allclaimresult[i].claima * userData[`wina`]
        totalclaimobject.totala += allclaimresult[i].a * userData[`wina`]
        totalclaimobject.total += allclaimresult[i].a * userData[`wina`]
      }
      if (allclaimresult[i].c) {
        totalclaimobject.claimc += allclaimresult[i].claimc * userData[`winc`]
        totalclaimobject.claim += allclaimresult[i].claimc * userData[`winc`]
        totalclaimobject.totalc += allclaimresult[i].c * userData[`winc`]
        totalclaimobject.total += allclaimresult[i].c * userData[`winc`]
      }
    }
    this.setState({ allclaim: allclaim.result, userData: allclaim.userData, totalObject: totalclaimobject })
  }

  async getClaimUser() {
    const allUser = await claimGetClaimUsers(this.props.username, this.props.token)
    this.setState({ allUser: allUser.result })
  }

  async setSelectedDate(date, mode) {
    this.setState({
      [mode]: date,
    });
  }

  async updateClaim(item) {
    const updateClaimObject = {
      id: item.id,
      claimb: item.claimb,
      claims: item.claims,
      claima1: item.claima1,
      claimc: item.claimc,
      claima: item.claima,
    }
    const claimUpdateResult = await claimUpdateClaim(this.props.username, this.props.token, updateClaimObject)
    if (claimUpdateResult.error){
      this.openNotification(claimUpdateResult.error, '')
    } else if (claimUpdateResult.message && claimUpdateResult.message === 'Claim Updated Successful') {
      this.openNotification('增加成功', '')
      this.handleClose()
      this.getClaims();
    }
  }

  updateItem(updateindex, key, newValue) {
    this.setState(prevState => ({
      allclaim: prevState.allclaim.map((item, index) =>
        index === updateindex ? { ...item, [key]: newValue } : item
      )
    }));
  }

  enter(e, item) {
    if (e.key === 'Enter') {
      this.updateClaim(item)
    }
  }

  render() {
    return (
      <div fluid style={{ fontFamily: 'cursive', backgroundImage: 'linear-gradient(#D0F0F5, #E7EDFF, #F0E8FF)', minHeight: '100vh' }}>
        <Header style={{ position: 'absolute', top: 0}}/>
        <Alert className='AlertPage' style={{ zIndex: 99, position: 'fixed', right: 0, top: 80 }}show={this.state.showNotification} variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
          <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
        </Alert>
        <Modal centered show={this.state.uploadModalShow} onHide={this.handleClose} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              上传 TXT
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div className="dcc" style={{ width: '100%', marginBottom: 30, marginTop: 15 }}>
                <textarea
                  className="form-control"
                  style={{ width: '100%', height: 350, fontWeight: 'bold' }}
                  value={this.state.FileResultWord}
                  readOnly={false}
                  onChange={(e) => this.ChangeReceipt(e)}
                />
              </div>
              <div 
                onDragOver={this.onDragOver}
                // onDragLeave={this.onDragLeave}
                onDrop={this.onDrop}
                onClick={this.openFileDialog}
                style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px dashed #747171', outline: 'none', backgroundColor: '#f0f0f0ff', width: '100%', height: 70}}
              >
                <span>Upload Files</span>
              </div>
              <input
                key={this.state.FileName}
                onChange={(event) => {
                  this.UploadFiletxt(event)
                }}
                onClick={(event) => event.target.value = ''}
                multiple={false}
                ref={this.fileInputRef}
                type='file'
                hidden
              />
              <div style={{ marginBottom: 20, fontWeight: 'bold' }}>File : {this.state.FileName || ''}</div>
              <div style={{ width: '100%', paddingBottom: 20, display: 'flex', justifyContent: 'space-evenly' }}>
                <button style={{ textAlign: 'center', backgroundColor: '#EE3E13', color: 'white', width: 200, fontWeight: 'bold', marginRight: 20 }}
                  disabled={this.state.disabled}
                  onClick={() => this.CleanData()}
                  className="btn my-cusomized-button button2 MenubarTitle">
                    清楚
                </button>
                <button style={{ textAlign: 'center', backgroundColor: '#3C96F4', color: 'white', width: 200, fontWeight: 'bold' }}
                  disabled={this.state.disabled}
                  onClick={() => this.claimUpload()}
                  className="btn my-cusomized-button button2 MenubarTitle">
                    确定 & 上传
                </button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => this.handleClose()}>关闭</Button>
            <Button variant="danger" onClick={() => this.ConfirmDelete()}>确定删除</Button>
          </Modal.Footer>
        </Modal>
        <div className='UserListView'>
          <div className='UserListInsideView'>
            <h2 className='TitleSize'>卜字</h2>
            <div style={{ marginLeft: 20, display: 'flex', alignItems: 'center'}}>
              <div style={{ fontWeight: 'bold' }}>从</div>
              <div style={{ marginLeft: 10, width: 130 }}>
                <DatePicker
                  onChange={(date) => this.setSelectedDate(date, 'fromDate')}
                  dateFormat='dd-MM-yyyy'
                  placeholder="Date"
                  maxDate={new Date()}
                  // minDate={new Date(this.state.FromDate)}
                  selected={this.state.fromDate}
                  value={this.state.fromDate}
                  className={"form-control StyleDatePicker"}
                />
              </div>
              <div style={{ marginLeft: 10, fontWeight: 'bold' }}>到</div>
              <div style={{ marginLeft: 10, marginRight: 10, width: 130 }}>
                <DatePicker
                  onChange={(date) => this.setSelectedDate(date, 'toDate')}
                  dateFormat='dd-MM-yyyy'
                  placeholder="Date"
                  maxDate={new Date()}
                  minDate={this.state.fromDate}
                  selected={this.state.toDate}
                  value={this.state.toDate}
                  className={"form-control StyleDatePicker"}
                />
              </div>
              <div style={{ marginLeft: 10, fontWeight: 'bold', marginRight: 10,  }}>用户</div>
              <Form.Select className='UsrListInput' value={this.state.selectedUser} onChange={(e) => this.setState({ selectedUser: e.target.value })}>
                {this.state.allUser.map((item) => <option value={item}>{item}</option>)}
              </Form.Select>
              <button className="button2" onClick={() => this.getClaims()}>寻找</button>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className='UserListButton'>
              <button className="buttonAdd" onClick={() => this.setState({ uploadModalShow: true })}>上传 TXT</button>
            </div>
          </div>
        </div>
        <div className="tableFixed">
          <Table striped bordered hover responsive style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }} className='userList'>
            <thead className='userList'>
              <tr>
                <th style={{ width: 30 }}>ID</th>
                <th style={{ width: 70 }}>用户</th>
                <th style={{ width: 110 }}>字期</th>
                <th style={{ width: 50 }}>游戏</th>
                <th style={{ width: 50 }}>位置</th>
                <th style={{ width: 60 }}>字</th>
                <th style={{ width: 50 }}>单号</th>
                <th style={{ width: 100 }}>B</th>
                <th style={{ width: 100 }}>S</th>
                <th style={{ width: 100 }}>A1</th>
                <th style={{ width: 100 }}>C</th>
                <th style={{ width: 100 }}>A</th>
                <th style={{ width: 100 }}>行动</th>
              </tr>
            </thead>
            <tbody className='userList'>
              {this.state.allclaim.map((item, index) => 
                <tr key={index}>
                  <td style={{ width: 30 }}>{item.id}</td>
                  <td style={{ width: 70 }}>{item.user}</td>
                  <td style={{ width: 110 }}>{moment(item.date).format('DD-MM-YYYY')}</td>
                  <td style={{ width: 50 }}>{item.platform}</td>
                  <td style={{ width: 50 }}>{item.position}</td>
                  <td style={{ width: 60 }}>{item.word}</td>
                  <td style={{ width: 50 }}>{item.orderNo}</td>
                  <td style={{ width: 100 }}>
                    {item.b ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <Form.Control style={{ width: 80}} value={item.claimb} onKeyDown={(e) => this.enter(e, item)} onChange={(e) => this.updateItem(index, 'claimb', e.target.value)}/>
                        <div style={{marginRight: 10, fontSize: 20}}> / {item.b}</div>
                      </div>
                      <div style={{fontSize: 20, color: item.claimb === item.b ? 'green' : 'red'}}> {(item.claimb * this.state.userData[`winb${item.position}`]).toFixed(2)}/{(item.b * this.state.userData[`winb${item.position}`]).toFixed(2)}</div>
                    </div> : <div></div>}
                  </td>
                  <td style={{ width: 100 }}>
                    {item.s ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <Form.Control style={{ width: 80}} value={item.claims} onKeyDown={(e) => this.enter(e, item)} onChange={(e) => this.updateItem(index, 'claims', e.target.value)}/>
                        <div style={{marginRight: 10, fontSize: 20}}> / {item.s}</div>
                      </div>
                      {this.state.userData[`wins${item.position}`] && <div style={{fontSize: 20, color: item.claims === item.s ? 'green' : 'red'}}> {(item.claims * this.state.userData[`wins${item.position}`]).toFixed(2)}/{(item.s * this.state.userData[`winb${item.position}`]).toFixed(2)}</div>}
                    </div> : <div></div>}
                  </td>
                  <td style={{ width: 100 }}>
                    {item.a1 ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <Form.Control style={{ width: 80}} value={item.claima1} onKeyDown={(e) => this.enter(e, item)} onChange={(e) => this.updateItem(index, 'claima1', e.target.value)}/>
                        <div style={{marginRight: 10, fontSize: 20}}> / {item.a1}</div>
                      </div>
                      {this.state.userData[`wina${item.position}`] && <div style={{fontSize: 20, color: item.claima1 === item.a1 ? 'green' : 'red'}}> {(item.claima1 * this.state.userData[`wina1`]).toFixed(2)}/{(item.a1 * this.state.userData[`wina1`]).toFixed(2)}</div>}
                    </div> : <div></div>}
                  </td>
                  <td style={{ width: 100 }}>
                    {item.c ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <Form.Control style={{ width: 80}} value={item.claimc} onKeyDown={(e) => this.enter(e, item)} onChange={(e) => this.updateItem(index, 'claimc', e.target.value)}/>
                        <div style={{marginRight: 10, fontSize: 20}}> / {item.c}</div>
                      </div>
                      {this.state.userData[`winc`] && <div style={{fontSize: 20, color: item.claimc === item.c? 'green' : 'red'}}> {(item.claimc * this.state.userData[`winc`]).toFixed(2)}/{(item.c * this.state.userData[`winc`]).toFixed(2)}</div>}
                    </div> : <div></div>}
                  </td>
                  <td style={{ width: 100 }}>
                    {item.a ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <Form.Control style={{ width: 80}} value={item.claima} onKeyDown={(e) => this.enter(e, item)} onChange={(e) => this.updateItem(index, 'claima', e.target.value)}/>
                        <div style={{marginRight: 10, fontSize: 20}}> / {item.a}</div>
                      </div>
                      {this.state.userData[`winc`] && <div style={{fontSize: 20, color: item.claima === item.a ? 'green' : 'red'}}> {(item.claima * this.state.userData[`wina`]).toFixed(2)}/{(item.a * this.state.userData[`wina`]).toFixed(2)}</div>}
                    </div> : <div></div>}
                  </td>
                  <td style={{ width: 100 }}>
                    <button className="button2" onClick={() => this.updateClaim(item)}>更新</button>
                  </td>
                </tr>)}
              <tr>
                <td style={{ width: 30 }}></td>
                <td style={{ width: 70 }}></td>
                <td style={{ width: 110 }}></td>
                <td style={{ width: 50 }}></td>
                <td style={{ width: 50 }}></td>
                <td style={{ width: 60 }}></td>
                <td style={{ width: 50 }}>总和</td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.totalb ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.totalb === this.state.totalObject.claimb ? 'green' : 'red'}}> {(this.state.totalObject.claimb).toFixed(2)}/{(this.state.totalObject.totalb).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.totals ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.totals === this.state.totalObject.claims ? 'green' : 'red'}}> {(this.state.totalObject.claims).toFixed(2)}/{(this.state.totalObject.totals).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.totala1 ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.totala1 === this.state.totalObject.claima1 ? 'green' : 'red'}}> {(this.state.totalObject.claima1).toFixed(2)}/{(this.state.totalObject.totala1).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.totalc ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.totalc === this.state.totalObject.claimc ? 'green' : 'red'}}> {(this.state.totalObject.claimc).toFixed(2)}/{(this.state.totalObject.totalc).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.totala ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.totala === this.state.totalObject.claima ? 'green' : 'red'}}> {(this.state.totalObject.claima).toFixed(2)}/{(this.state.totalObject.totala).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
                <td style={{ width: 100 }}>
                  {this.state.totalObject.total ? <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div style={{fontSize: 20, color: this.state.totalObject.total === this.state.totalObject.claim ? 'green' : 'red'}}> {(this.state.totalObject.claim).toFixed(2)}/{(this.state.totalObject.total).toFixed(2)}</div>
                  </div> : <div></div>}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.username,
    token: state.token,
    role: state.role,
  };
}
  
function mapDispatchToProps(dispatch) {
  return {
    
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(ClaimData);